import { render, staticRenderFns } from "./TaskPriorityTable.vue?vue&type=template&id=ed53eeae&"
import script from "./TaskPriorityTable.vue?vue&type=script&lang=js&"
export * from "./TaskPriorityTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports